/// <reference path="pocmemberform.js" />
import React from 'react';
import {FormCheck} from 'react-bootstrap';
import '../../../styles/Forms.css';

export function AccessCheckBox(props) {
    return (
        <FormCheck
            inline
            label={props.label}
            checked={props.checked}
            name="access"
            type="checkbox"
            id={props.id}
            disabled={props.disabled}
            onChange={(e) => { props.set(e.target.checked) }}
        />
    );
}